import React, { Component } from 'react';
import shuffleIcon from '../crossing-arrows.svg';
import rotate from '../reload.svg';
import './GalleryControls.css';
import FilterIcon from '../searchicon';

class GalleryControls extends Component {
  render() {
    return (
      <div className="allControls">
        <div className='filter'>
          <label htmlFor='filter'>Filter</label>
          <div className="input-icon-wrap">
            <span className="input-icon"><FilterIcon /></span>
            <input
              type='text'
              name='filter'
              id='filter'
              className='input-with-icon'
              value={this.props.isFiltered ? this.props.filterQuery : ''}
              onChange={this.props.keywordFilter}
              ref={this.props.filterField}
            />
          </div>

          <div className="button control" onClick={this.props.clearFilter} style={!this.props.isFiltered ? { visibility: 'hidden' } : {}}>clear</div>
        </div>
        <div className="controls">
          <div className="button control sort" onClick={this.props.onChronologicalClick}>{this.props.sortingMethod !== 'newest' ? 'Oldest on Top' : 'Newest on Top'}</div>
          <div className="button control shuffle" onClick={this.props.onShuffleClick}>Randomize <img src={shuffleIcon} alt="randomize" /></div>
          <div className="button control rotate" onClick={this.props.onRotateClick}>Rotate <img src={rotate} alt="rotate" /></div>
        </div>
      </div>
    );
  }
}

export default GalleryControls;


// WEBPACK FOOTER //
// ./src/Components/GalleryControls.jsx